import { billOfMaterialsIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";
import { billOfMaterialsStatusSchema } from "./bill-of-materials-types";

export const bulkUpdateBillOfMaterials = {
  name: "bulkUpdateBillOfMaterials" as const,
  input: z.object({
    billOfMaterialsIds: z.array(billOfMaterialsIdFormat.schema),
    status: billOfMaterialsStatusSchema.optional(),
    addTags: z.array(z.string()).optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
